import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import {get} from 'lodash'
import React, {Component} from 'react'
import {Checkbox, Col, DatePicker, Divider, Form, Row} from 'antd'
import './style.css'
import {compose} from 'recompose'

const CheckboxOptions = ({columns}) =>
  columns.map(col => (
    <Col span={12}>
      <Checkbox value={col.accessor}>{col.Header}</Checkbox>
    </Col>
  ))

const {RangePicker} = DatePicker

const ClientSelect = compose(
  withUrlFetch({
    name: 'clients',
    url: 'clients/?status=Active',
    cache: true,
  }),
  withSpinning,
)(CustomSelect)

class Options extends Component {
  render() {
    const {columns, formValues} = this.props
    const {getFieldDecorator} = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 15},
      },
    }
    return (
      <Form className="steps-content">
        <div className={'center_modal'}>
          <div className={'big_title'}>Export Options</div>
        </div>

        <Divider orientation="left" style={{marginTop: 10}}>
          Filter Data
        </Divider>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Company'}>
              {getFieldDecorator('company._id', {
                initialValue: get(formValues, 'company._id'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Company!',
                  },
                ],
              })(<OrganisationsSelect placeholder={'Company'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Client'}>
              {getFieldDecorator('client._id', {
                initialValue: get(formValues, 'client._id'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a name!',
                  },
                ],
              })(
                <ClientSelect
                  placeholder={'Select an Client'}
                  keyAtr={'member._id'}
                  valueAtr={'member.fn'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Date'}>
              {getFieldDecorator('date', {
                initialValue: get(formValues, 'date'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Date!',
                  },
                ],
              })(<RangePicker style={{width: '100%'}} />)}
            </Form.Item>
          </Col>
        </Row>

        <Divider orientation="left" style={{marginTop: 10}}>
          Desired Columns
        </Divider>
        <Row>
          <Form.Item>
            {getFieldDecorator('columns', {
              initialValue: columns.map(col => col.accessor),
              rules: [
                {
                  required: true,
                  message: 'Please Select a Column or More!',
                },
              ],
            })(
              <Checkbox.Group className={'checkbox_group'}>
                <CheckboxOptions columns={columns} />
              </Checkbox.Group>,
            )}
          </Form.Item>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Options)
